import AvApi from '@availity/api-axios';
import { getDeveloperHubPublicApiUrl } from '../config';

class EarlyAccessApi extends AvApi {
  constructor() {
    super({
      url: getDeveloperHubPublicApiUrl('early-access'),
      api: false,
      withCredentials: false,
      sessionBust: false,
    });
  }

  async postEarlyAccess(data: Record<string, unknown>): Promise<void> {
    await this.create(data);
  }
}

export default new EarlyAccessApi();
